import { render, staticRenderFns } from "./TextCreationIndexCardContainer.vue?vue&type=template&id=735c76ad&scoped=true"
import script from "./TextCreationIndexCardContainer.vue?vue&type=script&lang=js"
export * from "./TextCreationIndexCardContainer.vue?vue&type=script&lang=js"
import style0 from "./TextCreationIndexCardContainer.vue?vue&type=style&index=0&id=735c76ad&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "735c76ad",
  null
  
)

export default component.exports